import { ConnectDisconnectButton } from 'shared/components';

const LoginView = (): JSX.Element => {
  return <ConnectDisconnectButton />;
};

export default LoginView;
